__turbopack_context__.v({
  "address": "a879Za_address",
  "addressText": "a879Za_addressText",
  "details": "a879Za_details",
  "header": "a879Za_header",
  "image": "a879Za_image",
  "layout": "a879Za_layout",
  "name": "a879Za_name",
  "row": "a879Za_row",
  "rowContent": "a879Za_rowContent",
  "rowLabel": "a879Za_rowLabel",
  "rowValue": "a879Za_rowValue",
  "rows": "a879Za_rows",
  "titleGroup": "a879Za_titleGroup",
  "viewButton": "a879Za_viewButton",
});
